import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { PasswordForm } from '../../assets/models/password.form';

/**
 * Validator per centralizzare la logica di cambio password
 */
@Injectable({ providedIn: 'root' })
export class MatchPasswordValidator {

  public matchPassword(passwordForm: AbstractControl): ValidationErrors | undefined {
    const formValue = passwordForm.value as PasswordForm;

    const password = formValue.password;
    const retypedPassword = formValue.retypePassword;

    return password !== retypedPassword ? { noMatch: true } : undefined;
  }

}
